module.exports = __webpack_public_path__ + "img/bg4.1a469753.png";